import { mutatorAction } from 'satcheljs';
import { connectedAccountsStore } from '../../store/store';
export var updateAdvancedDisplayName = mutatorAction('updateAdvancedDisplayName', function (displayName) {
    var store = connectedAccountsStore();
    store.connectAdvancedState.displayName = displayName;
});
//# sourceMappingURL=updateAdvancedDisplayName.js.map